export function toCsv<T extends Record<string, unknown>>(
  rows: T[],
  columns: Array<{ key: keyof T; label: string }>,
): string {
  const header = columns.map((c) => escapeCell(c.label)).join(',')
  const body = rows.map((r) => columns.map((c) => escapeCell(r[c.key])).join(','))
  return [header, ...body].join('\n')
}

// Characters that Excel / Sheets interpret as the start of a live formula.
// Prefixing with a single quote tells the spreadsheet to treat the cell as
// literal text, which prevents an attacker (or careless user) from putting
// `=HYPERLINK(...)` or `=cmd|...` in a note field that runs when the owner
// later opens the exported CSV. The leading quote is invisible to the user.
const CSV_FORMULA_PREFIX = /^[=+\-@\t\r]/

function escapeCell(v: unknown): string {
  if (v == null) return ''
  let s = String(v)
  if (CSV_FORMULA_PREFIX.test(s)) s = "'" + s
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return '"' + s.replaceAll('"', '""') + '"'
  }
  return s
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
